export default (number: number): string => {
  if (number === undefined || number === null || number === 0) {
    return '$0.00'
  }
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  })

  return formatter.format(number)
}
